import AppRoute from "models/AppRoute"
import { Guid } from "@/types"

interface ILinkLabelsRouteParams {
    categoryId: Guid | "noCategory"
}

const LinkLabelsRoute = new AppRoute<ILinkLabelsRouteParams>({
    route: "/link-labels",
    navbar: true,
    authRequired: true,
})

export default LinkLabelsRoute
